import { alpha } from "@mui/material/styles";

// Draw the tree as branches: a solid trunk running down the left edge of
// every nested group, with a short stub reaching out to each item's icon —
// colour-coded per branch so Plant → WBS → category → item reads as a drawn,
// labeled tree instead of plain indentation.
export const treeViewSx = (theme) => {
  const structuralLine = alpha(theme.palette.primary.main, 0.45);
  const inertLine = alpha(theme.palette.text.primary, 0.22);
  const accentLine = alpha(theme.palette.warning.main, 0.75);

  const trunk = (color, width = 2) => ({
    borderLeft: `${width}px solid ${color}`,
  });
  const stub = (color, width = 2) => ({
    content: '""',
    position: "absolute",
    top: "50%",
    left: "-14px",
    width: "14px",
    height: 0,
    borderTop: `${width}px solid ${color}`,
  });

  return {
    flexGrow: 1,
    overflowY: "auto",
    px: 1,
    py: 1,
    "& .MuiTreeItem-content": { py: 0.5, position: "relative" },
    // Section headings (Procurement, Project Control) - still a caption row
    // rather than a named item, but the rows they head are their children
    // now, so they open and close like any other folder: they keep the arrow
    // and answer to a click.
    "& .tree-section-label > .MuiTreeItem-content": {
      background: (theme) => alpha(theme.palette.text.disabled, 0.04),
      borderRadius: "6px",
      mt: 1,
      mb: 0.25,
      px: 1,
      py: "2px !important",
      cursor: "pointer",
      "&:hover": {
        background: (theme) => alpha(theme.palette.text.disabled, 0.09),
      },
      "& .MuiTreeItem-label": {
        fontSize: "10px",
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: "text.disabled",
        py: 0,
      },
      // Sized to the heading's own 10px type, so the arrow reads as part of
      // the caption rather than looming over it.
      "& .MuiTreeItem-iconContainer": {
        width: "14px",
        marginRight: "2px",
        color: "text.disabled",
        "& svg": { fontSize: "14px" },
      },
    },
    "& .MuiTreeItem-group": {
      marginLeft: "15px",
      paddingLeft: "14px",
      ...trunk(structuralLine),
    },
    "& .MuiTreeItem-group > .MuiTreeItem-root > .MuiTreeItem-content::before":
      stub(structuralLine),
    "& .branch-inert > .MuiTreeItem-group": trunk(inertLine, 1.5),
    "& .branch-inert > .MuiTreeItem-group > .MuiTreeItem-root > .MuiTreeItem-content::before":
      stub(inertLine, 1.5),
    "& .branch-accent > .MuiTreeItem-group": trunk(accentLine),
    "& .branch-accent > .MuiTreeItem-group > .MuiTreeItem-root > .MuiTreeItem-content::before":
      stub(accentLine),
  };
};
